define("auth/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "auth/resolver", "auth/config/environment"], function (_exports, _engine, _emberLoadInitializers, _resolver, _environment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const {
    modulePrefix
  } = _environment.default;

  class Eng extends _engine.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "modulePrefix", modulePrefix);

      _defineProperty(this, "Resolver", _resolver.default);

      _defineProperty(this, "dependencies", {
        services: ['alerts', 'auth', 'cache', 'dialogManager', 'errors', 'instagram', 'intl', 'linkedin', 'locale', 'onboarding', 'plans', 'pinterest', 'router', 'session', 'segment', 'segmentEvents', 'social/facebook-auth', 'social/instagram-business', 'store', 'subscriptions', 'tiktok', 'twitter', 'userConfig'],
        externalRoutes: ['account.overview', 'plans', 'plans.plan', 'cluster.schedule', 'cluster.collect.contribute', 'subscription']
      });
    }

  }

  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = Eng;
  _exports.default = _default;
});